import z from "zod/v4";

export const ExecutionMetricsSchema = z.object({
  startTime: z.number(),
  endTime: z.number(),
  duration: z.number(),
  memoryUsed: z.number().optional(),
  tokensUsed: z.number().optional(),
  toolCallCount: z.number().optional(),
});

export type ExecutionMetrics = z.infer<typeof ExecutionMetricsSchema>;
